import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Returns user from userProfile state
 */
export default function useUser() {
    return useAppSelector((state) => state?.userProfile.user)
}